export default "__VITE_ASSET__B75kW3Uh__"